import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { mapGetters } from 'vuex';
import { PhCloudArrowUp, PhFolder, PhImage, PhGear } from '@phosphor-icons/vue';
import AccountMenu from './AccountMenu.vue';
import BottomTabBar from './BottomTabBar.vue';
const SHELL_HIDDEN_ROUTES = new Set(['login', 'adminLogin', 'blockimg', 'whiteliston', 'notFound']);
export default {
  name: 'AppShell',
  components: {
    AccountMenu,
    BottomTabBar
  },
  computed: {
    ...mapGetters(['userConfig', 'adminLoggedIn', 'userLoggedIn']),
    hideChrome() {
      return SHELL_HIDDEN_ROUTES.has(this.$route.name);
    },
    brandText() {
      return this.userConfig?.ownerName || 'CDNone';
    },
    brandHref() {
      return this.adminLoggedIn ? '/dashboard' : '/';
    },
    primaryItems() {
      const t = key => this.$t(`appShell.${key}`);
      const items = [{
        key: 'upload',
        to: '/',
        icon: PhCloudArrowUp,
        label: t('upload'),
        match: ['home']
      }];
      if (this.adminLoggedIn) {
        items.push({
          key: 'files',
          to: '/dashboard',
          icon: PhFolder,
          label: t('files'),
          match: ['dashboard']
        });
      }
      items.push({
        key: 'browse',
        to: '/browse',
        icon: PhImage,
        label: t('browse'),
        match: ['publicBrowse']
      });
      if (this.adminLoggedIn) {
        items.push({
          key: 'settings',
          to: '/systemConfig',
          icon: PhGear,
          label: t('settings'),
          match: ['systemConfig', 'customerConfig']
        });
      }
      return items;
    },
    activeTabKey() {
      const found = this.primaryItems.find(item => this.isActive(item));
      return found ? found.key : null;
    },
    accountItems() {
      return [];
    }
  },
  methods: {
    isActive(item) {
      return item.match.includes(this.$route.name);
    },
    handleAccountSelect(action) {
      this.$emit('account-action', action);
    }
  }
};